import { roundToCents } from "@common/helpers/monetary";
import { MatchedSchedule } from "@common/schemas/domains/accounting/scheduleMatchedDisplay.schema";
import { ScheduleApplicationStatus } from "@common/types/domains/accounting/schedule";

export interface MatchedSchedulesSummary {
    /** Invoices or transactions carrying the schedules. */
    sourceCount: number;
    /** Only when every matched schedule shares it. */
    status: ScheduleApplicationStatus | null;
    termEnd: string | null;
    remainingAmount: number;
}

export function summarizeMatchedSchedules(
    schedules: MatchedSchedule[],
): MatchedSchedulesSummary {
    const statuses = new Set(schedules.map((schedule) => schedule.status));
    const termEnds = schedules.flatMap((schedule) =>
        schedule.termEnd === null ? [] : [schedule.termEnd],
    );
    return {
        sourceCount: new Set(schedules.map((schedule) => schedule.sourceId))
            .size,
        status: statuses.size === 1 ? [...statuses][0] : null,
        termEnd: termEnds.sort().at(-1) ?? null,
        remainingAmount: roundToCents(
            schedules.reduce(
                (total, schedule) => total + schedule.remainingAmount,
                0,
            ),
        ),
    };
}
